import { AiFillLinkedin, AiFillYoutube, AiFillTwitterCircle, AiFillGithub, AiFillFacebook } from 'react-icons/ai';

export const SOCIAL_ICONS = [
    {
        icon: <AiFillLinkedin size={23} />,
        href: "https://www.linkedin.com/in/zobayerhosen"
    },
    {
        icon: <AiFillYoutube size={23} />,
        href: "https://www.youtube.com/c/"
    },
    {
        icon: <AiFillTwitterCircle size={23} />,
        href: "https://twitter.com/"
    },
    {
        icon: <AiFillGithub size={23} />,
        href: "https://github.com/zobayerhb"
    },
    {
        icon: <AiFillFacebook size={23} />,
        href: "https://www.facebook.com/zobayerhosenbiplob"
    },
]
